import { ErrorHandler, Injectable, inject } from '@angular/core';

import { ChunkLoadErrorHandlerService } from '../chunk-load-error-handler.service';
import { LoggerService } from './logger.service';

@Injectable()
export class LoggerErrorHandlerService extends ErrorHandler {
  private loggerService = inject(LoggerService);
  private chunkLoadErrorHandler = inject(ChunkLoadErrorHandlerService);

  override handleError(error: unknown): void {
    if (this.chunkLoadErrorHandler.handleIfChunkLoadError(error)) return;
    this.loggerService.logException(error);
  }
}
